// jshint module: true

function randomHash() {
  return Math.random().toString(36).slice(2, -2);
}

export{randomHash};
